
import EditIcon from "components/icon/EditIcon";
import React from "react";
import RecoveryForm from "./RecoveryRegistrationForm";

interface RecoverySectionProps {
  isEditMode: boolean;
  isAssetRegistrar: boolean;
  referral?: any;
  recoveryFormData: any;
  isEditingRecovery: boolean;
  showRecoveryForm: boolean;
  hasRecoveryData: boolean;
  hasRecoveryCourtData: boolean;
  onRecoveryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRecoverySubmit: (e: React.FormEvent) => void;
  onRecoveryEditClick: () => void;
  onCancelRecoveryEdit: () => void;
  onAddRecoveryDetails: () => void;
  onForwardToCoordinator: () => void;
  onOpenCourtPopup: () => void;
}

export const RecoverySection: React.FC<RecoverySectionProps> = ({
  isEditMode,
  isAssetRegistrar,
  referral,
  recoveryFormData,
  hasRecoveryData,
  hasRecoveryCourtData,
  onRecoveryChange,
  onRecoverySubmit,
  onRecoveryEditClick,
  onCancelRecoveryEdit,
  onAddRecoveryDetails,
  onForwardToCoordinator,
  onOpenCourtPopup,
  isEditingRecovery,
  showRecoveryForm,
}) => {
  // Early return if conditions aren't met
  if (
    !isEditMode ||
    !isAssetRegistrar ||
    referral?.action_status !== "Asset Recovery Request Approved"
  ) {
    return null;
  }

  const shouldShowForm = !hasRecoveryData || isEditingRecovery;

  return (
    <div className="">
      <div className="bg-white shadow-md rounded-lg p-4 mt-3">
        <div className="flex justify-between items-center">
          <h3 className="text-base font-semibold mb-4">
            Recovery Information
          </h3>
          {hasRecoveryData &&
            !isEditingRecovery && (
              <button
                type="button"
                onClick={onRecoveryEditClick}
                className="flex items-center gap-2 px-4 py-2 text-black rounded-lg transition-colors"
              >
                <EditIcon />
                Edit
              </button>
            )}
        </div>
        
        {shouldShowForm && (
          <RecoveryForm
            recoveryFormData={recoveryFormData}
            onRecoveryChange={onRecoveryChange}
            onRecoverySubmit={onRecoverySubmit}
            isEditingRecovery={isEditingRecovery}
            onCancel={onCancelRecoveryEdit}
          />
        )}
        
      
      </div>
    </div>
  );
};